import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import Button from 'flarum/common/components/Button';
import ChooseBountyAmount from './ChooseBountyAmount';
import Backers from './Backers';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import BountyAddedEventPost from './BountyAddedEventPost';
export default function () {
  app.postComponents.bountyAdded = BountyAddedEventPost;
  const canAddBounty = function (discussion) {
    const tags = discussion.tags() || [];
    const bountyTags = tags.filter(tag => tag && tag.blomstraBountyProduct());
    return app.session?.user?.exists && bountyTags.length > 0;
  };
  const enablePayToSupport = function (discussion) {
    if (canAddBounty(discussion)) {
      discussion.save({
        blomstraBountiesEnabled: true
      }).then(() => m.redraw());
    }
  };
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    const discussion = this.discussion;
    const tags = discussion.tags() || [];
    const bountyTag = tags.find(tag => tag && tag.blomstraBountyProduct());
    if (bountyTag && discussion.bountiesEnabled()) {
      items.add('backers', m(Backers, {
        discussion: discussion
      }), 90);
    }
    if (bountyTag && discussion.bountiesEnabled()) {
      items.add('add-bounty', m(Button, {
        className: "Button Button--primary",
        onclick: () => app.modal.show(ChooseBountyAmount, {
          for: this.discussion,
          product: bountyTag.blomstraBountyProduct()
        })
      }, app.translator.trans('floxum-payments.forum.bounties.purchase-control')), 90);
    }
    if (bountyTag && !discussion.bountiesEnabled() && discussion.canEnableBounties()) {
      items.add('enable-bounties', m(Button, {
        className: "Button",
        icon: "fas fa-hand-holding-heart",
        onclick: () => enablePayToSupport(discussion)
      }, app.translator.trans('floxum-payments.forum.bounties.enable-control')), 90);
    }
  });
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    const discussion = this.attrs.discussion;
    const bountyTag = (discussion.tags() || []).find(tag => tag && tag.blomstraBountyProduct());
    if (bountyTag && discussion.bountiesEnabled()) {
      items.add('bounty', m("span", {
        className: "TagLabel"
      }, app.translator.trans('floxum-payments.forum.backers-widget.label', {
        currency: discussion.bountyCurrencySymbol(),
        sum: discussion.totalBounty()
      })),
      // Before tags which is 8, but before reply username which is 0
      // Otherwise it's pushed out of the screen by a combination of many tags + long usernames on mobile
      5);
    }
  });
  extend(DiscussionListState.prototype, 'sortMap', function (map) {
    if (app.forum.blomstraBountiesEnabled()) {
      map.mostBacked = '-blomstraTotalBounty';
    }
    return map;
  });
}